module.exports = __webpack_public_path__ + "img/diagnostic-history-section-en.d649bc8c.jpg";